export const setlanguage = (context, pro) => {
    context.commit('setlanguage', pro);
};
export const clearlanguage = (context, pro) => {
    context.commit('clearlanguage', pro);
};
